export default {
  logInfo(msg: string) {
    // tslint:disable-next-line:no-console
    console.log(msg)
  },

  resetConnection(address: string, success: () => void, failure: (error: any) => void) {
    bluetoothle.isConnected((res) => {
      bluetoothle.disconnect(success, failure, {address})
    }, success, {address})
  },

  init(success: () => void, failure: (error: string) => void) {
    const doInit = () => {
      bluetoothle.isInitialized((result) => {
        this.logInfo(JSON.stringify(result))
        if (result.isInitialized) {
          this.logInfo('device already initialized, running')
          success()
        } else {
          this.logInfo('device not initialized, initializing')
          bluetoothle.initialize((initResult) => {
            if (initResult.status === 'enabled') {
              this.logInfo('device initialized, running')
              success()
            } else {
              failure('BLUETOOTH_DISABLED')
            }
          })
        }
      })
    }

    const currentDevicePlatform = (window as any).device.platform

    if (currentDevicePlatform === 'iOS') {
      doInit()
    } else {
      bluetoothle.hasPermission((r1) => {
        if (!r1.hasPermission) {
          bluetoothle.requestPermission((r2) => {
            if (!r2.requestPermission) {
              failure('permission denied')
              return
            }
            doInit()
          })
        } else {
          this.logInfo('already has permission')
          doInit()
        }
      }, () => {
        failure('permission error')
      })
    }
  },
  searchByName(name: string, success: (address: string) => void, failure: (error: string) => void) {
    this.init(() => {
      this.logInfo('init finished')

      let timeoutHolder: any

      const doScan = () => {
        timeoutHolder = setTimeout(() => {
          bluetoothle.stopScan(() => {
            this.logInfo('stopped scan')
            failure('scan stopped')
          }, () => {
            // failure
          })
        }, 15000)
        bluetoothle.startScan(
          (res) => {
            this.logInfo('started scan...')
            if (res.status === 'scanResult' && res.name === name) {
              bluetoothle.stopScan((result) => {
                this.logInfo(result.status)
              }, (error) => {
                this.logInfo(error.message)
              })
              success(res.address)
            }
          }, (error) => {
            failure(error.message)
          },
        )
      }

      bluetoothle.isScanning((result) => {
        if (result.isScanning) {
          // Stop the scan and restart
          bluetoothle.stopScan(
            () => {
              doScan()
            }, (error) => {
              this.logInfo(error.message)
            },
          )
        } else {
          doScan()
        }
      })

    }, failure)
  },
}
